import type { ECommissionType, IMaterial } from './Product';
import type Product from './Product';

export class Affiliation {
  visible: boolean;
  infinity_funnel: boolean;
  funnel_commission: number;
  auto_affiliation: boolean;
  comission_type: ECommissionType;
  comission_value: number;
  recurring_comission_value: number;
  recurring_comission_type: ECommissionType;

  constructor(affiliation: Product) {
    this.visible = affiliation.visible;
    this.infinity_funnel = affiliation.infinity_funnel;
    this.funnel_commission = affiliation.funnel_commission;
    this.auto_affiliation = affiliation.auto_affiliation;
    this.comission_type = affiliation.comission_type;
    this.comission_value = affiliation.comission_value;
    this.recurring_comission_type = affiliation.recurring_comission_type;
    this.recurring_comission_value = affiliation.recurring_comission_value;
  }
}

export class AffiliateInstructions {
  affiliate_instructions: string;
  affiliation_contract: string;

  constructor(instructions: Product) {
    this.affiliate_instructions = instructions.affiliate_instructions;
    this.affiliation_contract = instructions.affiliation_contract;
  }
}

export class Recruiter {
  recruit: boolean;
  recruit_commission_type: ECommissionType;
  recruit_commission_value: number;
  recruit_max_sales: number;

  constructor(recruiter: Product) {
    this.recruit = recruiter.recruit;
    this.recruit_commission_type = recruiter.recruit_commission_type;
    this.recruit_commission_value = recruiter.recruit_commission_value;
    this.recruit_max_sales = recruiter.recruit_max_sales;
  }
}

export class Materials {
  materials: IMaterial[];

  constructor(materials: Product) {
    this.materials = materials.materials;
  }
}
